import { render, staticRenderFns } from "./TagsField.vue?vue&type=template&id=b14c4bf6"
import script from "./TagsField.vue?vue&type=script&lang=js"
export * from "./TagsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports